import { createGlobalStyle } from 'styled-components';
// import { ThemeType } from './themes/dark';

export const GlobalStyles = createGlobalStyle`
  :root {
    color-scheme: dark;
  }

  * {
    box-sizing: border-box;
    /* Custom Scrollbar for all elements */
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: ${props => props.theme.border || props.theme.background};
      border-radius: 4px;
      &:hover {
        background-color: ${props => props.theme.textSecondary || props.theme.placeholderColor};
      }
    }
  }

  ::selection {
    background-color: ${props => props.theme.primary}50;
    color: ${props => props.theme.text};
  }

  body {
    margin: 0;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
      Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: ${props => props.theme.background};
    color: ${props => props.theme.text};
    transition: background-color 0.3s ease, color 0.3s ease;
    overflow-x: hidden;
    line-height: 1.5;
    /*
      Degradê dos neutros Hexium — o mesmo tratamento do webwidget, para as duas telas lerem como
      um produto só.

      Substituiu dois gradientes radiais em rgba(79, 70, 229) — índigo, mais uma marca estrangeira
      herdada de template, junto com o azul do Twitter que saiu dos componentes.

      Vertical e com background-attachment fixed: o degradê pertence à JANELA, não ao documento.
      Sem isso ele se estica com a altura da página e a cor desliza durante a rolagem.
    */
    background-image: linear-gradient(
      180deg,
      ${props => props.theme.background} 0%,
      ${props => props.theme.backgroundDeep} 100%
    );
    background-attachment: fixed;
  }

  /* Focus rings */
  *:focus-visible {
    outline: 2px solid ${props => props.theme.primary};
    outline-offset: 2px;
  }

  /* Reset buttons */
  button {
    font-family: inherit;
  }
  
  .root-layout {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    width: 100%;
  }
  
  .content-container {
    display: flex;
    flex-direction: row;
    height: 100vh;
    width: 100%;
    position: relative;
  }

  .main-content {
    flex: 1;
    margin-left: 260px; /* Alinhado com a largura do Sidebar (expanded) */
    margin-top: 64px; /* Alinhado com a altura do Header */
    overflow-x: hidden;
    transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1), width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    padding: 24px;
    width: calc(100% - 260px);
    min-height: calc(100vh - 64px);
  }

  .main-content[data-sidebar-collapsed="true"] {
    margin-left: 80px; /* Alinhado com a largura do Sidebar (collapsed) */
    width: calc(100% - 80px);
  }

  /* Responsividade para tablets */
  @media (max-width: 1024px) {
    .main-content {
      margin-left: 80px;
      width: calc(100% - 80px);
      padding: 16px;
    }

    .main-content[data-sidebar-collapsed="true"] {
      margin-left: 80px;
      width: calc(100% - 80px);
    }
  }

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    .content-container {
      flex-direction: column;
    }

    .main-content {
      margin-left: 0;
      margin-top: 64px; /* Altura do header no mobile */
      width: 100%;
      padding: 12px;
      min-height: calc(100vh - 64px);
    }

    .main-content[data-sidebar-collapsed="true"] {
      margin-left: 0;
      width: 100%;
    }
  }

  /* Responsividade para mobile pequeno */
  @media (max-width: 480px) {
    .main-content {
      padding: 8px;
      margin-top: 60px;
      min-height: calc(100vh - 60px);
    }
  }

  /* Utilitários responsivos */
  .hide-mobile {
    @media (max-width: 768px) {
      display: none !important;
    }
  }

  .hide-desktop {
    @media (min-width: 769px) {
      display: none !important;
    }
  }

  .show-mobile {
    display: none;
    @media (max-width: 768px) {
      display: block !important;
    }
  }

  .show-mobile-flex {
    display: none;
    @media (max-width: 768px) {
      display: flex !important;
    }
  }
`;